<template>
  <transition name="fade">
    <div
      class="sb-panel"
      :class="[
        currentPanelSize == 2 ? 'medium' : '',
        currentPanelSize == 1 ? 'small' : '',
      ]"
      :style="{
        maxWidth: width + 'px',
      }"
    >
      <span class="sb-close" v-show="closeButton" @click="togglePanel">
        &#10005;
      </span>
      <span class="sb-heading">{{ heading }}</span>
      <span v-if="currentPanelSize == 1" class="sb-expand" @click="toggleExpand"
        >+</span
      >
      <slot class="sb-content"></slot>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    closeButton: { type: Boolean, default: true },
    heading: { type: String },
    collection: { type: String },
    ctacollection: { type: String },
    width: { type: Number },
    size: { type: Number, default: 3 },
  },
  computed: {
    ...mapState(["currentPanelSize"]),
  },
  methods: {
    setLSWithExpiry(key, value, ttl) {
      const now = new Date();
      const item = {
        value: value,
        expiry: now.getTime() + ttl,
      };
      localStorage.setItem(key, JSON.stringify(item));
    },

    togglePanel() {
      if (this.ctacollection) {
        if (this.ctacollection == "similarProducts") {
          this.setLSWithExpiry("sb-cta-similar-timeout", true, 86400000);
        }
        this.$store.commit("CLOSE_PANEL", {
          collection: this.collection,
          ctacollection: this.ctacollection,
        });
      } else {
        this.$store.commit("CLOSE_PANEL", this.collection);
      }
    },
    toggleExpand() {
      this.$store.commit("EXPAND_CURRENT_PANEL");
    },
  },
};
</script>

<style scoped>
/* .sb-heading { */
/* display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--shopbox-text);
  background: var(--shopbox-background-dark);
  width: 100%;
  height: 30px;
  margin: 0 !important;
  font-size: 18px;
  position: absolute;
  left: 0;
  top: 0;
  padding: 2px 6px;
  box-sizing: border-box;
  box-shadow: 0 1px 4px 0 rgba(117, 141, 166, 0.1142);
} */
#shopbox header * {
  font-weight: 100;
}
#shopbox .sb-panel {
  background: var(--shopbox-background-light);
  box-shadow: 0 1px 6px 0 rgba(117, 141, 166, 0.45) !important;
  border-radius: 8px !important;
  position: fixed;
  bottom: 72px;
  left: 72px;
  z-index: 2147483646;
  padding: 4px 8px 16px;
  /* max-height: 280px; */
  max-width: 765px;
  width: 100%;
  min-height: 280px;
}
#shopbox .shopbox-right .sb-panel {
  right: 72px;
  left: unset;
}
#shopbox .small {
  max-width: 255px !important;
}
#shopbox .medium {
  max-width: 510px !important;
}

#shopbox .sb-heading {
  margin-bottom: 0;
  margin-top: 4px;
  display: block;
  font-size: 16px;
  margin-left: 14px;
  /* text-transform: uppercase; */
}

#shopbox .sb-close {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 34px;
  height: 34px;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2147483647;
  color: inherit;
  transition: all 200ms ease-out;
}
#shopbox .sb-cta .sb-close {
  color: #000;
}
#shopbox .ctaPortrait .sb-close {
  top: -8px;
  right: -8px;
}
#shopbox .ctaPortrait:hover .sb-close {
  opacity: 1;
}
@media (min-width: 768px) {
  #shopbox .ctaPortrait .sb-close {
    opacity: 0;
  }
}
#shopbox .sb-content {
  max-height: calc(100% - 30px);
}
#shopbox .fade-enter-active {
  transition: opacity 160ms;
}
#shopbox .fade-leave-active {
  transition: opacity 160ms;
}
#shopbox .fade-enter,  #shopbox .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  visibility: hidden;
  transform: translateY(8px);
}
</style>
